const routers = [
    {
      path: '/nextIndex',
      component: () => import(/* webpackChunkName: "index" */'../pages/nextIndex.vue')
    },
    // {
    //   path: '/newIndex',
    //   component: () => import(/* webpackChunkName: "index" */'../pages/newIndex.vue')
    // },
    {
        path: '/index',
        component: () => import(/* webpackChunkName: "index" */'../pages/index.vue')
    },
    {
      path: '/signUp',
      component: () => import(/* webpackChunkName: "sign-up" */'../pages/signUp.vue')
    },
    {
      path: '/eventDescription',
      component: () => import(/* webpackChunkName: "event-description" */'../pages/eventDescription.vue')
    },
    {
      path: '/login',
      component: () => import(/* webpackChunkName: "index" */'../pages/login.vue')
    },
    {
      path: '/submission',
      component: () => import(/* webpackChunkName: "index" */'../pages/submission.vue')
    },
    {
      path: '/ranking',
      component: () => import(/* webpackChunkName: "index" */'../pages/ranking.vue')
    },
    {
      path: '/newRanking',
      component: () => import(/* webpackChunkName: "index" */'../pages/newRanking.vue')
    },
    {
      path: '/weekList',
      component: () => import(/* webpackChunkName: "index" */'../pages/weekList.vue')
    },
]

export default [
    ...routers,
    {
      path: '*',
      redirect: '/nextIndex'
    }
  ]